import React from 'react';
import { CheckIcon } from 'lucide-react';
const included = ['Las 8 habilidades completas · 116 páginas', 'BONUS 1: Banco de Producciones Escritas', 'BONUS 2: Banco de Debates para Secundaria', 'BONUS 3: 50 Actividades de Ciudadanía', 'BONUS 4: Del Aula al Mundo'];
const extras = ['Actividades listas para imprimir', 'Recursos aplicables a diferentes materias', 'Material pensado específicamente para adolescentes', 'Acceso digital inmediato y de por vida'];
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-171" data-mp="opcl6wm3uz7y">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-[#17A2AE] shadow-2xl" data-id="element-172" data-mp="oqw3esrbnkcd">
        <h2 className="text-[20px] md:text-2xl font-black mb-4 text-center text-white uppercase" data-id="element-173" data-mp="ymz2fpqvn2v3">
          Todo lo que vas a recibir hoy
        </h2>

        <div className="mb-4" data-id="element-174" data-mp="2e1whlhjivrpc">
          <h3 className="text-2xl font-bold mb-3" data-id="element-175" data-mp="2e5c0ywk8bmwk">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-lg md:text-xl" data-id="element-176" data-mp="2a1mfifyuplfr">
            {included.map((s, i) => <li key={s} className={`flex items-start ${i === 0 ? 'font-bold' : ''}`} data-id="element-177" data-mp="1nc6y6dye9esf" data-mpi={i}>
                <span className="text-[#4FD1DB] mr-3" data-id="element-178" data-mp="1sb0esf8z9lwt">•</span>
                <span data-id="element-179" data-mp="1wdn68f1ql4th">{s}</span>
              </li>)}
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-180" data-mp="1wbkbxitjwpiy">
          <h3 className="text-2xl font-bold mb-3" data-id="element-181" data-mp="21bos17qjri8n">Además vas a tener:</h3>
          <ul className="space-y-2 text-lg" data-id="element-182" data-mp="14n0nne7r7thp">
            {extras.map(e => <li key={e} className="flex items-start" data-id="element-183" data-mp="14ke5ylr5fxlr">
                <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-184" data-mp="18p4128dzh85m" />
                <span data-id="element-185" data-mp="1dmx4itnwjo27">{e}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}